import React from "react";
import "./comments.scss";
import CloseIcon from "@mui/icons-material/Close";

interface CommentsProps {
  isOpen: boolean;
  onClose: () => void;
  content: any;
}

const Comments: React.FC<CommentsProps> = ({ isOpen, onClose, content }) => {
  if (!isOpen) {
    return null;
  }
  const SortContent = content.slice().reverse();
  return (
    <div className="commentss-overlayy">
      <div className="commentss-contents">
        <div className="comment-close-buttons" onClick={onClose}>
          {/* &times; */}
          <CloseIcon
            style={{
              color: "grey",
              fontSize: "1.3rem",
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              transition: "transform 0.2s, color 0.2s",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.color = "#FF5E4F";
              e.currentTarget.style.transform = "scale(1.2)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.color = "grey";
              e.currentTarget.style.transform = "scale(1)";
            }}
          />
        </div>
        {SortContent.map((item: any, index: number) => (
          <div key={index} className="comment">
            <div className="comment-header">
              <div className="comment-name">{item.created_by} - </div>
              {/* commented on */}

              {index === 0 ? "New Comments On" : "Earlier Comments On"}

              <div className="comment-date"> {item.created_date}</div>
            </div>
            <div className="comment-text">{item.comment}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Comments;
